import { render, staticRenderFns } from "./BorderCustomsV2.vue?vue&type=template&id=3d4e3aaf"
import script from "./BorderCustomsV2.vue?vue&type=script&lang=js"
export * from "./BorderCustomsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports